import { render, staticRenderFns } from "./WhatsappShareButton.vue?vue&type=template&id=cf959276&scoped=true"
import script from "./WhatsappShareButton.vue?vue&type=script&lang=js"
export * from "./WhatsappShareButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf959276",
  null
  
)

export default component.exports